export default {
  methods: {
    zeroOrLess (value) {
      return value > 0 ? 0 : value
    },

    zeroOrGreater (value, test) {
      return value < 0 ? 0 : value
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/formatters.js